import styles from './CardTeam.module.css';
import sfu from '../../assets/icons/sfu.svg';
import uprigrht from '../../assets/icons/upright.svg';
import avatarPlaceholder from '../../assets/icons/avatar.svg';

function CardTeam({ teamName, balance, members, onButtonClick }) {
  return (
    <div className={styles.cardTeam}>
      <div className={styles.header}>
        <h3 className={styles.name}>{teamName}</h3>
        <button className={styles.button} onClick={onButtonClick}>
          <img src={uprigrht} alt="share" />
        </button>
      </div>
      <div className={styles.balance}>Баланс: <img src={sfu} alt="" /> {balance}</div>
      <div className={styles.members}>
        {members.slice(0, 5).map((member, index) => (
          <img
            key={index}
            src={member.avatar}
            alt={member.name || `Участник ${index + 1}`}
            className={styles.avatar}
            onError={(event) => {
              event.currentTarget.src = avatarPlaceholder;
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default CardTeam;
